module.exports = __webpack_public_path__ + "images/d2f9e6fa75f1f4bbdc4b355419e37f96.png";